import type { Component } from 'vue'
import type { DecorationWidgetConfig, DecorationWidgetModule } from './types'

// common
import { widgetConfig as adGridConfig } from './common/ad-grid/config'
import AdGridTemplate from './common/ad-grid/template.vue'
import { widgetConfig as bannerConfig } from './common/banner/config'
import BannerTemplate from './common/banner/template.vue'
import BannerSettings from './common/banner/settings.vue'
import { widgetConfig as blankConfig } from './common/blank/config'
import BlankTemplate from './common/blank/template.vue'
import { widgetConfig as buttonConfig } from './common/button/config'
import ButtonTemplate from './common/button/template.vue'
import { widgetConfig as cardListConfig } from './common/card-list/config'
import CardListTemplate from './common/card-list/template.vue'
import { widgetConfig as categoryTabsConfig } from './common/category-tabs/config'
import CategoryTabsTemplate from './common/category-tabs/template.vue'
import CategoryTabsSettings from './common/category-tabs/settings.vue'
import { widgetConfig as dataListConfig } from './common/data-list/config'
import DataListTemplate from './common/data-list/template.vue'
import { widgetConfig as dividerConfig } from './common/divider/config'
import DividerTemplate from './common/divider/template.vue'
import { widgetConfig as floatingActionConfig } from './common/floating-action/config'
import FloatingActionTemplate from './common/floating-action/template.vue'
import { widgetConfig as horizontalMenuConfig } from './common/horizontal-menu/config'
import HorizontalMenuTemplate from './common/horizontal-menu/template.vue'
import HorizontalMenuSettings from './common/horizontal-menu/settings.vue'
import { widgetConfig as imageConfig } from './common/image/config'
import ImageTemplate from './common/image/template.vue'
import ImageSettings from './common/image/settings.vue'
import { widgetConfig as menuItemConfig } from './common/menu-item/config'
import MenuItemTemplate from './common/menu-item/template.vue'
import { widgetConfig as navConfig } from './common/nav/config'
import NavTemplate from './common/nav/template.vue'
import NavSettings from './common/nav/settings.vue'
import { widgetConfig as noticeConfig } from './common/notice/config'
import NoticeTemplate from './common/notice/template.vue'
import { widgetConfig as richTextConfig } from './common/rich-text/config'
import RichTextTemplate from './common/rich-text/template.vue'
import RichTextSettings from './common/rich-text/settings.vue'
import { widgetConfig as searchConfig } from './common/search/config'
import SearchTemplate from './common/search/template.vue'
import { widgetConfig as titleConfig } from './common/title/config'
import TitleTemplate from './common/title/template.vue'
import { widgetConfig as videoConfig } from './common/video/config'
import VideoTemplate from './common/video/template.vue'
import { widgetConfig as orderCardConfig } from './common/order-card/config'
import OrderCardTemplate from './common/order-card/template.vue'

// mall
import { widgetConfig as couponStripConfig } from './mall/coupon-strip/config'
import CouponStripTemplate from './mall/coupon-strip/template.vue'
import { widgetConfig as memberCardConfig } from './mall/member-card/config'
import MemberCardTemplate from './mall/member-card/template.vue'
import { widgetConfig as productDetailConfig } from './mall/product-detail/config'
import ProductDetailTemplate from './mall/product-detail/template.vue'
import ProductDetailSettings from './mall/product-detail/settings.vue'
import { widgetConfig as productInfoConfig } from './mall/product-info/config'
import ProductInfoTemplate from './mall/product-info/template.vue'
import { widgetConfig as productListConfig } from './mall/product-list/config'
import ProductListTemplate from './mall/product-list/template.vue'
import { widgetConfig as productMediaConfig } from './mall/product-media/config'
import ProductMediaTemplate from './mall/product-media/template.vue'
import { widgetConfig as productReviewsConfig } from './mall/product-reviews/config'
import ProductReviewsTemplate from './mall/product-reviews/template.vue'
import { widgetConfig as purchaseBarConfig } from './mall/purchase-bar/config'
import PurchaseBarTemplate from './mall/purchase-bar/template.vue'
import { widgetConfig as serviceGuaranteeConfig } from './mall/service-guarantee/config'
import ServiceGuaranteeTemplate from './mall/service-guarantee/template.vue'

// guoxue
import { widgetConfig as aiConsultCardConfig } from './guoxue/ai-consult-card/config'
import AiConsultCardTemplate from './guoxue/ai-consult-card/template.vue'
import { widgetConfig as brandHeaderConfig } from './guoxue/brand-header/config'
import BrandHeaderTemplate from './guoxue/brand-header/template.vue'
import { widgetConfig as contentListConfig } from './guoxue/content-list/config'
import ContentListTemplate from './guoxue/content-list/template.vue'
import { widgetConfig as dailySignBadgeConfig } from './guoxue/daily-sign-badge/config'
import DailySignBadgeTemplate from './guoxue/daily-sign-badge/template.vue'
import { widgetConfig as expertListConfig } from './guoxue/expert-list/config'
import ExpertListTemplate from './guoxue/expert-list/template.vue'
import { widgetConfig as fortuneCardConfig } from './guoxue/fortune-card/config'
import FortuneCardTemplate from './guoxue/fortune-card/template.vue'
import { widgetConfig as fortuneToolsConfig } from './guoxue/fortune-tools/config'
import FortuneToolsTemplate from './guoxue/fortune-tools/template.vue'
import { widgetConfig as liveCardsConfig } from './guoxue/live-cards/config'
import LiveCardsTemplate from './guoxue/live-cards/template.vue'
import { widgetConfig as liveListConfig } from './guoxue/live-list/config'
import LiveListTemplate from './guoxue/live-list/template.vue'
import { widgetConfig as messageListConfig } from './guoxue/message-list/config'
import MessageListTemplate from './guoxue/message-list/template.vue'
import { widgetConfig as orderListConfig } from './guoxue/order-list/config'
import OrderListTemplate from './guoxue/order-list/template.vue'
import { widgetConfig as shopListConfig } from './guoxue/shop-list/config'
import ShopListTemplate from './guoxue/shop-list/template.vue'
import { widgetConfig as updatePopupConfig } from './guoxue/update-popup/config'
import UpdatePopupTemplate from './guoxue/update-popup/template.vue'
import { widgetConfig as walletCardConfig } from './guoxue/wallet-card/config'
import WalletCardTemplate from './guoxue/wallet-card/template.vue'

// content
import { widgetConfig as contentArticleBodyConfig } from './content/content-article-body/config'
import ContentArticleBodyTemplate from './content/content-article-body/template.vue'
import { widgetConfig as contentArticleFeedConfig } from './content/content-article-feed/config'
import ContentArticleFeedTemplate from './content/content-article-feed/template.vue'
import { widgetConfig as contentArticleHeaderConfig } from './content/content-article-header/config'
import ContentArticleHeaderTemplate from './content/content-article-header/template.vue'
import { widgetConfig as contentBodyConfig } from './content/content-body/config'
import ContentBodyTemplate from './content/content-body/template.vue'
import { widgetConfig as contentFeedConfig } from './content/content-feed/config'
import ContentFeedTemplate from './content/content-feed/template.vue'
import { widgetConfig as contentHeaderConfig } from './content/content-header/config'
import ContentHeaderTemplate from './content/content-header/template.vue'
import { widgetConfig as contentInteractionBarConfig } from './content/content-interaction-bar/config'
import ContentInteractionBarTemplate from './content/content-interaction-bar/template.vue'
import { widgetConfig as contentMomentCaptionConfig } from './content/content-moment-caption/config'
import ContentMomentCaptionTemplate from './content/content-moment-caption/template.vue'
import { widgetConfig as contentMomentFeedConfig } from './content/content-moment-feed/config'
import ContentMomentFeedTemplate from './content/content-moment-feed/template.vue'
import { widgetConfig as contentMomentMediaConfig } from './content/content-moment-media/config'
import ContentMomentMediaTemplate from './content/content-moment-media/template.vue'
import { widgetConfig as contentVideoFeedConfig } from './content/content-video-feed/config'
import ContentVideoFeedTemplate from './content/content-video-feed/template.vue'
import { widgetConfig as contentVideoPlayerConfig } from './content/content-video-player/config'
import ContentVideoPlayerTemplate from './content/content-video-player/template.vue'

// cms
import { widgetConfig as cmsAggregateEntriesConfig } from './cms/cms-aggregate-entries/config'
import CmsAggregateEntriesTemplate from './cms/cms-aggregate-entries/template.vue'
import { widgetConfig as cmsArticleDetailConfig } from './cms/cms-article-detail/config'
import CmsArticleDetailTemplate from './cms/cms-article-detail/template.vue'
import { widgetConfig as cmsBannerConfig } from './cms/cms-banner/config'
import CmsBannerTemplate from './cms/cms-banner/template.vue'
import { widgetConfig as cmsCatalogListConfig } from './cms/cms-catalog-list/config'
import CmsCatalogListTemplate from './cms/cms-catalog-list/template.vue'
import { widgetConfig as cmsCatalogTreeConfig } from './cms/cms-catalog-tree/config'
import CmsCatalogTreeTemplate from './cms/cms-catalog-tree/template.vue'
import { widgetConfig as cmsContentTabsConfig } from './cms/cms-content-tabs/config'
import CmsContentTabsTemplate from './cms/cms-content-tabs/template.vue'
import { widgetConfig as cmsFeedConfig } from './cms/cms-feed/config'
import CmsFeedTemplate from './cms/cms-feed/template.vue'
import { widgetConfig as cmsGridEntriesConfig } from './cms/cms-grid-entries/config'
import CmsGridEntriesTemplate from './cms/cms-grid-entries/template.vue'
import { widgetConfig as cmsInteractionBarConfig } from './cms/cms-interaction-bar/config'
import CmsInteractionBarTemplate from './cms/cms-interaction-bar/template.vue'
import { widgetConfig as cmsSiteGridConfig } from './cms/cms-site-grid/config'
import CmsSiteGridTemplate from './cms/cms-site-grid/template.vue'
import { widgetConfig as cmsSiteHeaderConfig } from './cms/cms-site-header/config'
import CmsSiteHeaderTemplate from './cms/cms-site-header/template.vue'

// ticketing
import { widgetConfig as scenicLeadFormConfig } from './ticketing/scenic-lead-form/config'
import ScenicLeadFormTemplate from './ticketing/scenic-lead-form/template.vue'
import { widgetConfig as scenicMemberCardConfig } from './ticketing/scenic-member-card/config'
import ScenicMemberCardTemplate from './ticketing/scenic-member-card/template.vue'
import { widgetConfig as ticketGridConfig } from './ticketing/ticket-grid/config'
import TicketGridTemplate from './ticketing/ticket-grid/template.vue'
import { widgetConfig as ticketingHeroConfig } from './ticketing/ticketing-hero/config'
import TicketingHeroTemplate from './ticketing/ticketing-hero/template.vue'
import { widgetConfig as ticketingNoticeConfig } from './ticketing/ticketing-notice/config'
import TicketingNoticeTemplate from './ticketing/ticketing-notice/template.vue'
import { widgetConfig as ticketingProductListConfig } from './ticketing/ticketing-product-list/config'
import TicketingProductListTemplate from './ticketing/ticketing-product-list/template.vue'
import { widgetConfig as scenicHomeMediaConfig } from './scenic-home/scenic-home-media/config'
import ScenicHomeMediaTemplate from './scenic-home/scenic-home-media/template.vue'
import { widgetConfig as scenicHomeInfoConfig } from './scenic-home/scenic-home-info/config'
import ScenicHomeInfoTemplate from './scenic-home/scenic-home-info/template.vue'
import { widgetConfig as scenicHomeGoodsConfig } from './scenic-home/scenic-home-goods/config'
import ScenicHomeGoodsTemplate from './scenic-home/scenic-home-goods/template.vue'
import { widgetConfig as scenicHomeGalleryConfig } from './scenic-home/scenic-home-gallery/config'
import ScenicHomeGalleryTemplate from './scenic-home/scenic-home-gallery/template.vue'
import { widgetConfig as scenicTicketMediaConfig } from './scenic-ticket/scenic-ticket-media/config'
import ScenicTicketMediaTemplate from './scenic-ticket/scenic-ticket-media/template.vue'
import { widgetConfig as scenicTicketInfoConfig } from './scenic-ticket/scenic-ticket-info/config'
import ScenicTicketInfoTemplate from './scenic-ticket/scenic-ticket-info/template.vue'
import { widgetConfig as scenicTicketDetailConfig } from './scenic-ticket/scenic-ticket-detail/config'
import ScenicTicketDetailTemplate from './scenic-ticket/scenic-ticket-detail/template.vue'
import { widgetConfig as scenicTicketNoticeConfig } from './scenic-ticket/scenic-ticket-notice/config'
import ScenicTicketNoticeTemplate from './scenic-ticket/scenic-ticket-notice/template.vue'
import { widgetConfig as scenicTicketScenicConfig } from './scenic-ticket/scenic-ticket-scenic/config'
import ScenicTicketScenicTemplate from './scenic-ticket/scenic-ticket-scenic/template.vue'

// shell
import { widgetConfig as mxjlMapConfig } from './shell/mxjl-map/config'
import MxjlMapTemplate from './shell/mxjl-map/template.vue'
import { widgetConfig as mxjlMessageCenterConfig } from './shell/mxjl-message-center/config'
import MxjlMessageCenterTemplate from './shell/mxjl-message-center/template.vue'
import { widgetConfig as mxjlProfileCenterConfig } from './shell/mxjl-profile-center/config'
import MxjlProfileCenterTemplate from './shell/mxjl-profile-center/template.vue'
import { widgetConfig as newsFeedConfig } from './shell/news-feed/config'
import NewsFeedTemplate from './shell/news-feed/template.vue'
import NewsChannelsEditor from './shell/NewsChannelsEditor.vue'
import { widgetConfig as newsTopbarConfig } from './shell/news-topbar/config'
import NewsTopbarTemplate from './shell/news-topbar/template.vue'

// alumni
import { widgetConfig as alumniCardConfig } from './alumni/alumni-card/config'
import AlumniCardTemplate from './alumni/alumni-card/template.vue'
import { widgetConfig as classGroupsConfig } from './alumni/class-groups/config'
import ClassGroupsTemplate from './alumni/class-groups/template.vue'
import { widgetConfig as regionGroupsConfig } from './alumni/region-groups/config'
import RegionGroupsTemplate from './alumni/region-groups/template.vue'
import { widgetConfig as eventListConfig } from './alumni/event-list/config'
import EventListTemplate from './alumni/event-list/template.vue'
import { widgetConfig as newsListConfig } from './alumni/news-list/config'
import NewsListTemplate from './alumni/news-list/template.vue'
import { widgetConfig as alumniServiceListConfig } from './alumni/alumni-service-list/config'
import AlumniServiceListTemplate from './alumni/alumni-service-list/template.vue'

// crm
import { widgetConfig as customerStatsConfig } from './crm/customer-stats/config'
import CustomerStatsTemplate from './crm/customer-stats/template.vue'
import { widgetConfig as leadFormConfig } from './crm/lead-form/config'
import LeadFormTemplate from './crm/lead-form/template.vue'
import { widgetConfig as followUpListConfig } from './crm/follow-up-list/config'
import FollowUpListTemplate from './crm/follow-up-list/template.vue'

// oa
import { widgetConfig as oaWorkbenchSummaryConfig } from './oa/oa-workbench-summary/config'
import OaWorkbenchSummaryTemplate from './oa/oa-workbench-summary/template.vue'
import { widgetConfig as oaQuickLaunchConfig } from './oa/oa-quick-launch/config'
import OaQuickLaunchTemplate from './oa/oa-quick-launch/template.vue'
import { widgetConfig as oaTodoListConfig } from './oa/oa-todo-list/config'
import OaTodoListTemplate from './oa/oa-todo-list/template.vue'
import { widgetConfig as oaRequestListConfig } from './oa/oa-request-list/config'
import OaRequestListTemplate from './oa/oa-request-list/template.vue'

// gongzheng
import { widgetConfig as orderStatusConfig } from './gongzheng/order-status/config'
import OrderStatusTemplate from './gongzheng/order-status/template.vue'
import { widgetConfig as certificateListConfig } from './gongzheng/certificate-list/config'
import CertificateListTemplate from './gongzheng/certificate-list/template.vue'
import { widgetConfig as verifyCardConfig } from './gongzheng/verify-card/config'
import VerifyCardTemplate from './gongzheng/verify-card/template.vue'
import { widgetConfig as gongzhengServiceListConfig } from './gongzheng/gongzheng-service-list/config'
import GongzhengServiceListTemplate from './gongzheng/gongzheng-service-list/template.vue'

// microdrama
import { widgetConfig as bannerSwiperConfig } from './microdrama/banner-swiper/config'
import BannerSwiperTemplate from './microdrama/banner-swiper/template.vue'
import { widgetConfig as categoryGridConfig } from './microdrama/category-grid/config'
import CategoryGridTemplate from './microdrama/category-grid/template.vue'
import { widgetConfig as scriptListConfig } from './microdrama/script-list/config'
import ScriptListTemplate from './microdrama/script-list/template.vue'
import { widgetConfig as venueListConfig } from './microdrama/venue-list/config'
import VenueListTemplate from './microdrama/venue-list/template.vue'
import { widgetConfig as talentListConfig } from './microdrama/talent-list/config'
import TalentListTemplate from './microdrama/talent-list/template.vue'

// opc
import { widgetConfig as opcDemandCardConfig } from './opc/opc-demand-card/config'
import OpcDemandCardTemplate from './opc/opc-demand-card/template.vue'
import { widgetConfig as opcProviderCardConfig } from './opc/opc-provider-card/config'
import OpcProviderCardTemplate from './opc/opc-provider-card/template.vue'

// promotion
import { widgetConfig as couponCenterConfig } from './promotion/coupon-center/config'
import CouponCenterTemplate from './promotion/coupon-center/template.vue'
import { widgetConfig as promotionCouponStripConfig } from './promotion/promotion-coupon-strip/config'
import PromotionCouponStripTemplate from './promotion/promotion-coupon-strip/template.vue'

// erp
import { widgetConfig as purchaseListConfig } from './erp/purchase-list/config'
import PurchaseListTemplate from './erp/purchase-list/template.vue'
import { widgetConfig as erpProductListConfig } from './erp/erp-product-list/config'
import ErpProductListTemplate from './erp/erp-product-list/template.vue'
import { widgetConfig as erpOrderListConfig } from './erp/erp-order-list/config'
import ErpOrderListTemplate from './erp/erp-order-list/template.vue'

// market-selection
import { widgetConfig as marketProductListConfig } from './market-selection/market-product-list/config'
import MarketProductListTemplate from './market-selection/market-product-list/template.vue'

// pet
import { widgetConfig as petServiceListConfig } from './pet/pet-service-list/config'
import PetServiceListTemplate from './pet/pet-service-list/template.vue'

// form
import { widgetConfig as formFormConfig } from './form/form-form/config'
import FormFormTemplate from './form/form-form/template.vue'

const widgets: DecorationWidgetModule[] = [
  { ...adGridConfig, template: AdGridTemplate },
  { ...bannerConfig, template: BannerTemplate, settings: BannerSettings },
  { ...blankConfig, template: BlankTemplate },
  { ...buttonConfig, template: ButtonTemplate },
  { ...cardListConfig, template: CardListTemplate },
  { ...categoryTabsConfig, template: CategoryTabsTemplate, settings: CategoryTabsSettings },
  { ...dataListConfig, template: DataListTemplate },
  { ...dividerConfig, template: DividerTemplate },
  { ...floatingActionConfig, template: FloatingActionTemplate },
  { ...horizontalMenuConfig, template: HorizontalMenuTemplate, settings: HorizontalMenuSettings },
  { ...imageConfig, template: ImageTemplate, settings: ImageSettings },
  { ...menuItemConfig, template: MenuItemTemplate },
  { ...navConfig, template: NavTemplate, settings: NavSettings },
  { ...noticeConfig, template: NoticeTemplate },
  { ...richTextConfig, template: RichTextTemplate, settings: RichTextSettings },
  { ...searchConfig, template: SearchTemplate },
  { ...titleConfig, template: TitleTemplate },
  { ...videoConfig, template: VideoTemplate },
  { ...orderCardConfig, template: OrderCardTemplate },
  { ...couponStripConfig, template: CouponStripTemplate },
  { ...memberCardConfig, template: MemberCardTemplate },
  { ...productDetailConfig, template: ProductDetailTemplate, settings: ProductDetailSettings },
  { ...productInfoConfig, template: ProductInfoTemplate },
  { ...productListConfig, template: ProductListTemplate },
  { ...productMediaConfig, template: ProductMediaTemplate },
  { ...productReviewsConfig, template: ProductReviewsTemplate },
  { ...purchaseBarConfig, template: PurchaseBarTemplate },
  { ...serviceGuaranteeConfig, template: ServiceGuaranteeTemplate },
  { ...aiConsultCardConfig, template: AiConsultCardTemplate },
  { ...brandHeaderConfig, template: BrandHeaderTemplate },
  { ...contentListConfig, template: ContentListTemplate },
  { ...dailySignBadgeConfig, template: DailySignBadgeTemplate },
  { ...expertListConfig, template: ExpertListTemplate },
  { ...fortuneCardConfig, template: FortuneCardTemplate },
  { ...fortuneToolsConfig, template: FortuneToolsTemplate },
  { ...liveCardsConfig, template: LiveCardsTemplate },
  { ...liveListConfig, template: LiveListTemplate },
  { ...messageListConfig, template: MessageListTemplate },
  { ...orderListConfig, template: OrderListTemplate },
  { ...shopListConfig, template: ShopListTemplate },
  { ...updatePopupConfig, template: UpdatePopupTemplate },
  { ...walletCardConfig, template: WalletCardTemplate },
  { ...contentArticleBodyConfig, template: ContentArticleBodyTemplate },
  { ...contentArticleFeedConfig, template: ContentArticleFeedTemplate },
  { ...contentArticleHeaderConfig, template: ContentArticleHeaderTemplate },
  { ...contentBodyConfig, template: ContentBodyTemplate },
  { ...contentFeedConfig, template: ContentFeedTemplate },
  { ...contentHeaderConfig, template: ContentHeaderTemplate },
  { ...contentInteractionBarConfig, template: ContentInteractionBarTemplate },
  { ...contentMomentCaptionConfig, template: ContentMomentCaptionTemplate },
  { ...contentMomentFeedConfig, template: ContentMomentFeedTemplate },
  { ...contentMomentMediaConfig, template: ContentMomentMediaTemplate },
  { ...contentVideoFeedConfig, template: ContentVideoFeedTemplate },
  { ...contentVideoPlayerConfig, template: ContentVideoPlayerTemplate },
  { ...cmsAggregateEntriesConfig, template: CmsAggregateEntriesTemplate },
  { ...cmsArticleDetailConfig, template: CmsArticleDetailTemplate },
  { ...cmsBannerConfig, template: CmsBannerTemplate },
  { ...cmsCatalogListConfig, template: CmsCatalogListTemplate },
  { ...cmsCatalogTreeConfig, template: CmsCatalogTreeTemplate },
  { ...cmsContentTabsConfig, template: CmsContentTabsTemplate },
  { ...cmsFeedConfig, template: CmsFeedTemplate },
  { ...cmsGridEntriesConfig, template: CmsGridEntriesTemplate },
  { ...cmsInteractionBarConfig, template: CmsInteractionBarTemplate },
  { ...cmsSiteGridConfig, template: CmsSiteGridTemplate },
  { ...cmsSiteHeaderConfig, template: CmsSiteHeaderTemplate },
  { ...scenicLeadFormConfig, template: ScenicLeadFormTemplate },
  { ...scenicMemberCardConfig, template: ScenicMemberCardTemplate },
  { ...ticketGridConfig, template: TicketGridTemplate },
  { ...ticketingHeroConfig, template: TicketingHeroTemplate },
  { ...ticketingNoticeConfig, template: TicketingNoticeTemplate },
  { ...ticketingProductListConfig, template: TicketingProductListTemplate },
  { ...scenicHomeMediaConfig, template: ScenicHomeMediaTemplate },
  { ...scenicHomeInfoConfig, template: ScenicHomeInfoTemplate },
  { ...scenicHomeGoodsConfig, template: ScenicHomeGoodsTemplate },
  { ...scenicHomeGalleryConfig, template: ScenicHomeGalleryTemplate },
  { ...scenicTicketMediaConfig, template: ScenicTicketMediaTemplate },
  { ...scenicTicketInfoConfig, template: ScenicTicketInfoTemplate },
  { ...scenicTicketDetailConfig, template: ScenicTicketDetailTemplate },
  { ...scenicTicketNoticeConfig, template: ScenicTicketNoticeTemplate },
  { ...scenicTicketScenicConfig, template: ScenicTicketScenicTemplate },
  { ...mxjlMapConfig, template: MxjlMapTemplate },
  { ...mxjlMessageCenterConfig, template: MxjlMessageCenterTemplate },
  { ...mxjlProfileCenterConfig, template: MxjlProfileCenterTemplate },
  { ...newsFeedConfig, template: NewsFeedTemplate, settings: NewsChannelsEditor },
  { ...newsTopbarConfig, template: NewsTopbarTemplate, settings: NewsChannelsEditor },
  { ...alumniCardConfig, template: AlumniCardTemplate },
  { ...classGroupsConfig, template: ClassGroupsTemplate },
  { ...regionGroupsConfig, template: RegionGroupsTemplate },
  { ...eventListConfig, template: EventListTemplate },
  { ...newsListConfig, template: NewsListTemplate },
  { ...alumniServiceListConfig, template: AlumniServiceListTemplate },
  { ...customerStatsConfig, template: CustomerStatsTemplate },
  { ...leadFormConfig, template: LeadFormTemplate },
  { ...followUpListConfig, template: FollowUpListTemplate },
  { ...oaWorkbenchSummaryConfig, template: OaWorkbenchSummaryTemplate },
  { ...oaQuickLaunchConfig, template: OaQuickLaunchTemplate },
  { ...oaTodoListConfig, template: OaTodoListTemplate },
  { ...oaRequestListConfig, template: OaRequestListTemplate },
  { ...orderStatusConfig, template: OrderStatusTemplate },
  { ...certificateListConfig, template: CertificateListTemplate },
  { ...verifyCardConfig, template: VerifyCardTemplate },
  { ...gongzhengServiceListConfig, template: GongzhengServiceListTemplate },
  { ...bannerSwiperConfig, template: BannerSwiperTemplate },
  { ...categoryGridConfig, template: CategoryGridTemplate },
  { ...scriptListConfig, template: ScriptListTemplate },
  { ...venueListConfig, template: VenueListTemplate },
  { ...talentListConfig, template: TalentListTemplate },
  { ...opcDemandCardConfig, template: OpcDemandCardTemplate },
  { ...opcProviderCardConfig, template: OpcProviderCardTemplate },
  { ...couponCenterConfig, template: CouponCenterTemplate },
  { ...promotionCouponStripConfig, template: PromotionCouponStripTemplate },
  { ...purchaseListConfig, template: PurchaseListTemplate },
  { ...erpProductListConfig, template: ErpProductListTemplate },
  { ...erpOrderListConfig, template: ErpOrderListTemplate },
  { ...marketProductListConfig, template: MarketProductListTemplate },
  { ...petServiceListConfig, template: PetServiceListTemplate },
  { ...formFormConfig, template: FormFormTemplate }
]

const widgetsByType = new Map<string, DecorationWidgetModule>()

for (const widget of widgets) {
  widgetsByType.set(widget.type, widget)
  for (const alias of widget.aliases ?? []) {
    widgetsByType.set(alias, widget)
  }
}

export function listDecorationWidgets(): DecorationWidgetModule[] {
  return widgets
}

export function getDecorationWidget(type: string): DecorationWidgetModule | undefined {
  return widgetsByType.get(type)
}

export function getWidgetConfig(type: string): DecorationWidgetConfig | undefined {
  return getDecorationWidget(type)
}

export function getWidgetTemplate(type: string): Component | undefined {
  return getDecorationWidget(type)?.template
}

export function getWidgetSettings(type: string): Component | undefined {
  return getDecorationWidget(type)?.settings
}

export type { DecorationWidgetConfig, DecorationWidgetModule } from './types'
